function initVideoProgressTracker() {
  const embedElement = document.querySelector('.wistia_embed[data-video-id]');

  if (!embedElement) {
    return;
  }

  const videoId = embedElement.getAttribute('data-video-id');

  if (!videoId) {
    return;
  }

  let lastSentAt = 0;
  let lastProgress = -1;

  const resumeProgress = Number(embedElement.dataset.resumeProgress || 0);
  const resumeCompleted = embedElement.dataset.resumeCompleted === '1';

  const sendProgress = async (progress, completed = false, force = false) => {
    const clamped = Math.max(0, Math.min(100, Number(progress) || 0));
    const now = Date.now();

    if (!force) {
      const withinThrottleWindow = now - lastSentAt < 5000;
      const smallProgressDelta = Math.abs(clamped - lastProgress) < 2;

      if (withinThrottleWindow && smallProgressDelta) {
        return;
      }
    }

    lastSentAt = now;
    lastProgress = clamped;

    const body = {
      videoId,
      progress: clamped,
      completed,
    };

    if (window.csrfTokenName && window.csrfToken) {
      body[window.csrfTokenName] = window.csrfToken;
    }

    try {
      const response = await fetch('/video-progress/track', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': window.csrfToken || '',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        console.warn(`Video progress track request failed (${response.status}).`);
      }
    } catch (error) {
      console.debug('Video progress tracking failed:', error);
    }
  };

  window._wq = window._wq || [];
  window._wq.push({
    id: videoId,
    onReady(video) {
      const getPercent = () => {
        if (typeof video.time !== 'function' || typeof video.duration !== 'function') {
          return null;
        }

        const elapsed = Number(video.time());
        const duration = Number(video.duration());

        if (!Number.isFinite(elapsed) || !Number.isFinite(duration) || duration <= 0) {
          return null;
        }

        return (elapsed / duration) * 100;
      };

      if (!resumeCompleted && Number.isFinite(resumeProgress) && resumeProgress >= 2 && resumeProgress < 95) {
        const duration = typeof video.duration === 'function' ? Number(video.duration()) : NaN;

        if (Number.isFinite(duration) && duration > 0 && typeof video.time === 'function') {
          const targetSeconds = Math.max(0, Math.min(duration - 2, (duration * resumeProgress) / 100));

          if (targetSeconds >= 3) {
            video.time(targetSeconds);
            lastProgress = Math.max(lastProgress, resumeProgress);
          }
        }
      }

      video.bind('secondchange', (seconds) => {
        const duration = typeof video.duration === 'function' ? Number(video.duration()) : NaN;
        const elapsed = Number(seconds);

        if (!Number.isFinite(duration) || duration <= 0 || !Number.isFinite(elapsed)) {
          return;
        }

        const percent = (elapsed / duration) * 100;
        sendProgress(percent, percent >= 95, false);
      });

      video.bind('pause', () => {
        const percent = getPercent();
        if (percent !== null) {
          sendProgress(percent, percent >= 95, true);
        }
      });

      video.bind('end', () => {
        sendProgress(100, true, true);
      });

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          const percent = getPercent();
          if (percent !== null) {
            sendProgress(percent, percent >= 95, true);
          }
        }
      });

      window.addEventListener('beforeunload', () => {
        const percent = getPercent();
        if (percent !== null) {
          sendProgress(percent, percent >= 95, true);
        }
      });
    },
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVideoProgressTracker);
} else {
  initVideoProgressTracker();
}
